import { fromRangeToArray, returnIconDays } from './dateUtils/date-utils';
import catchAndThrow from '../errors/error.utils';
import ERRORS from '../errors/formatter.errors';
import moment from 'moment';
import {VACATION, VACATIONS_ABSENCES_STATES } from '../domain/constants';

const formatters = {

  formatAvailableVacations: (data) => {
    return {
      pendingDays: data.agreement,
      ownDays: data.free,
      christmasDays: data.christmas,
      lastYear: data.last_year
    };
  },

  formatHolidays: (national, local) => {
    let result;
    catchAndThrow(() => {
      result = [...national, ...local];
    }, ERRORS.FORMAT_HOLIDAYS);

    return result;
  },

  formatAllPeriods: (absences, vacations, holidays) => {
    let result;
    catchAndThrow(() => {
      result = [...absences, ...vacations, ...holidays];
    }, ERRORS.FORMAT_ALL_PERIODS);

    return result;
  },

  formatPeriodInDays: (allPeriods) => {
    let list = [];
    let id = 0;
    let iconDays = [];
    iconDays = returnIconDays(allPeriods);
    allPeriods.map((item) => {
      let startDate = item.startDate || item.date;
      let endDate = item.endDate || item.date || new Date();
      let status = item.status || '';
      let periodId = id++;
      let type = item.type || '';
      let code = item.code || '';
      list = list.concat(fromRangeToArray(startDate, endDate, status, periodId, type, code, iconDays));
    });
    return list;

  },

  getDayWithContent: (date, dayInEvents) => {
    let day = {
      content: moment(date).format('DD'),
    };
    if (dayInEvents.length > 0) {
      day.content = dayInEvents[0].html.content;
      if(dayInEvents.length > 1) {
        if(dayInEvents[1].status === VACATIONS_ABSENCES_STATES.requested && dayInEvents[1].type.includes(VACATION)){
          day.content = dayInEvents[1].html.content;
        }
      }
      
      const getClasses = day => day.html.classes;
      const reducer = (firstValue, currentValue) => `${firstValue} ${currentValue}`;
      day.classes = dayInEvents.map(getClasses).reduce(reducer);
    }

    return day;
  },

};

export default formatters;



// WEBPACK FOOTER //
// ./client/app/common/utils/periods.formatters.js